module.exports = __webpack_public_path__ + "static/media/LEA.167033ca.png";